import RelationshipMetadata from "../../RelationshipMetadata";

class WorkGroupWorkGroupAccountUserRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "WorkGroupWorkGroupEmployeeRelationshipMetadata";
        this.parentEnterpriseComponent = "WorkGroup";
        this.childEnterpriseComponent = "WorkGroupEmployee";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "WorkGroupUSID";
    }
}

export default WorkGroupWorkGroupAccountUserRelationshipMetadata;